/**
 * Created by wajidafaneh on 4/26/17.
 */
window.HMAPGeneralSettingsForm = function ($scope, $alert, settingsFactory, brand, brandServices) {
    var self = this;
    var formName = "hmap-general-settings-form";
    var _protected = BaseForm.call(self, formName, $scope);

    var orginalData = {};
    self.isSaving = false;
    self.brandId = brand.id;

    self.data = {
        name: null,
        description: null,
        facebook_url: null,
        instagram_url: null,
        twitter_url: null,
        linkedin_url: null,
        youtube_url: null,
        tiktok_url: null,
        url: null
    };

    var initFormData = function () {
        self.data = angular.copy(orginalData);
        self.validator.validation = {};
    };

    var resetOrginalData = function () {
        orginalData = angular.copy(self.data);
    };

    self.discard = function () {
        initFormData();
    };

    //Save the form
    self.save = function () {
        var defer = $q.defer();

        if (self.validator.validate()) {
            self.isSaving = true;

            var payload = {
                name: self.data['name'],
                description: self.data['description'],
                facebook_url: self.data['facebook_url'],
                instagram_url: self.data['instagram_url'],
                twitter_url:  self.data['twitter_url'],
                linkedin_url:  self.data['linkedin_url'],
                youtube_url:  self.data['youtube_url'],
                tiktok_url:  self.data['tiktok_url'],
                url: self.data['url'],
                apply_social_links_to_children: self.data['apply_social_links_to_children'],
                external_business_name: self.data['external_business_name'],
                apply_external_business_name_to_children: self.data['apply_external_business_name_to_children'],
                brand_id: brand.id
            };

            BrandAPI.updateBrandBasicInformation(payload)
                .then(function (result) {
                    self.isSaving = false;

                    resetOrginalData();

                    $alert({
                        content: $filter("translate")("Your settings were updated successfully."),
                        placement: 'top',
                        type: 'success',
                        show: true,
                        container: 'body',
                        templateUrl: "../modules/team_schedule/employer/settings/alerts/save_settings_alert/save_settings_alert.html",
                        duration: 3
                    });
                }, function (err) {
                    console.error("couldn't save your brand details", err);
                });
        } else {
            self.isSaving = false;

            defer.reject("Error validating form");
        }

        return defer.promise;
    };

    //init
    (function () {
        var promises = {};
        promises['GPData'] = GPSAPI.getGP(brand.id);
        promises['isMFAServiceEnabled'] = brandServices.check(brandServices.SERVICES.MFA, brand.id);

        $q.all(promises)
            .then(function (res) {
                self.isHighestParent = brand.id === res['GPData'].parent_id;
                self.isMFAServiceEnabled = res['isMFAServiceEnabled'];
            })
            .catch(function () {
            })
            .finally(function () {
                self.syncScope();
                settingsFactory.brandBasicInformation(brand.id)
                    .then(function (result) {
                        orginalData = result.data.data;
                        initFormData();
                    }, function (err) {
                        console.error("couldn't load your brand info", err);
                    })
            });
    })();
};
